
/*
 *  This file common.models.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { HttpEvent } from "@angular/common/http";
import { FormControl } from "@angular/forms";

export const PAGE_SIZE = 15;

export class PaginationModel {
  constructor(
    public pageNumber = 1,
    public pageSize = PAGE_SIZE
  ) { }
}

export const booleanFlag = {
  true: true,
  false: false
};

export interface languageListItem {
  templateLanguageId: number;
  templateLanguageName: string;
}

export interface EmployeeSearchModel {
  EmployeeCode: string;
  EmployeeName: string;
  Name: string;
}

export interface EmployeeAutoSearchItem {
  name: string;
  code: string;
  id: number;
  codeName: string;
  designation: string;
  imageVirtualPath: string;
  officialEmail: string;
  personalEmail: string;
  mobile: string;
  employeeStatusId: number | null;
}

export interface TResponseInExcel {
  body: {
    filePath: string;
  }
}

export interface LeaveType {
  leaveId: number;
  leaveCycle: string;
  leaveCycleStartMonthId: number,
  leaveCycleStartMonthName: string;
  leavePaidUnpaid: string;
  isActive: boolean;
  leaveCode: string;
  leaveName: string;
  isEncashmentAllowed: boolean;
  allowLeaveDonate: boolean;
  donateLeaveBalance: number;
}

export class LinksModel {
  constructor(
    public href?: string,
    public relation?: string,
    public method?: string
  ) { }
}


export interface RequestWorkflowAndStatusModel {
  isInvalid: boolean;
  reason: string;
}

export interface FinancialYearModel {
  financialYearId: number;
  financialYearStartDate: string;
  financialYearendDate: string;
  currentFinancialYear: boolean;
}

export type RequestSourceType = 'E' | 'T' | 'A';

export const monthDaysTill28 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];

export const monthlyDaysList = [
  { key: 1, value: '1' },
  { key: 2, value: '2' },
  { key: 3, value: '3' },
  { key: 4, value: '4' },
  { key: 5, value: '5' },
  { key: 6, value: '6' },
  { key: 7, value: '7' },
  { key: 8, value: '8' },
  { key: 9, value: '9' },
  { key: 10, value: '10' },
  { key: 11, value: '11' },
  { key: 12, value: '12' },
  { key: 13, value: '13' },
  { key: 14, value: '14' },
  { key: 15, value: '15' },
  { key: 16, value: '16' },
  { key: 17, value: '17' },
  { key: 18, value: '18' },
  { key: 19, value: '19' },
  { key: 20, value: '20' },
  { key: 21, value: '21' },
  { key: 22, value: '22' },
  { key: 23, value: '23' },
  { key: 24, value: '24' },
  { key: 25, value: '25' },
  { key: 26, value: '26' },
  { key: 27, value: '27' },
  { key: 28, value: '28' },
  { key: 31, value: 'Last day' },
];

export const monthlyDaysListFromTill31 = [
  { key: 10, value: '10' },
  { key: 11, value: '11' },
  { key: 12, value: '12' },
  { key: 13, value: '13' },
  { key: 14, value: '14' },
  { key: 15, value: '15' },
  { key: 16, value: '16' },
  { key: 17, value: '17' },
  { key: 18, value: '18' },
  { key: 19, value: '19' },
  { key: 20, value: '20' },
  { key: 21, value: '21' },
  { key: 22, value: '22' },
  { key: 23, value: '23' },
  { key: 24, value: '24' },
  { key: 25, value: '25' },
  { key: 26, value: '26' },
  { key: 27, value: '27' },
  { key: 28, value: '28' },
  { key: 31, value: 'Last day' },
  { key: 0, value: 'First day of next month' },
];
export const monthlyDaysListTill28Days = [
  { key: 1, value: '1' },
  { key: 2, value: '2' },
  { key: 3, value: '3' },
  { key: 4, value: '4' },
  { key: 5, value: '5' },
  { key: 6, value: '6' },
  { key: 7, value: '7' },
  { key: 8, value: '8' },
  { key: 9, value: '9' },
  { key: 10, value: '10' },
  { key: 11, value: '11' },
  { key: 12, value: '12' },
  { key: 13, value: '13' },
  { key: 14, value: '14' },
  { key: 15, value: '15' },
  { key: 16, value: '16' },
  { key: 17, value: '17' },
  { key: 18, value: '18' },
  { key: 19, value: '19' },
  { key: 20, value: '20' },
  { key: 21, value: '21' },
  { key: 22, value: '22' },
  { key: 23, value: '23' },
  { key: 24, value: '24' },
  { key: 25, value: '25' },
  { key: 26, value: '26' },
  { key: 27, value: '27' },
  { key: 28, value: '28' }
];


export interface LogonUserDetailModel {
  employeeId: number,
  employeeCode: string,
  salutation: number,
  salutationName: string,
  employeePhoto: string,
  employeeName: string,
  businessUnit: string,
  department: string,
  subDepartment: string,
  grade: string,
  designation: string,
  branch: string,
  subBranch: string,
  level: string,
  company: string,
  regionCode: string,
  region: string,
  imageVirtualPath: string,
  signatureFileName: string,
  signatureFilePath: string,
  signatureText: string,
  firstName: string,
  middleName: string,
  lastName: string,
  companyCode: string,
  businessUnitCode: string,
  designationCode: string,
  departmentCode: string,
  subDepartmentCode: string,
  gradeCode: string,
  levelCode: string,
  branchCode: string,
  subBranchCode: string,
  maritalId: string,
  personalEmail: string,
  officialEmail: string,
  staffId: string,
  gender: number,
  finalized: string,
  suspended: string,
  employeeStatusId: number,
  employeeStatus: string,
  employeeTypeId: number,
  employeeType: string,
  thumbnailFileName: string,
  uploadedFileName: string,
  mobileNo: string,
  isSeparationPending: string,
  dateOfBirth: Date | string,
  dateOfJoining: Date | string,
  dateOfMarriage: Date | string,
  domainCode: string,
  isEmailBlocked: boolean,
  isNumberVerified: string,
  identifier: {
    organizationKeyOne: number,
    organizationKeyTwo: number,
  },
  chatFileVirtualBasePath: string,
  kommunicateAppId: string,
  companySocialHandle: Array<{
    handleName: string,
    handleLink: string,
    handleImage: string,
    companyCode: string
  }>,
  firestoreDocumentId: string
  companyLogoPath?: string;
  enterpriseName?: string;
}

export interface TokenInfoModel {
  unique_name: string;
  domainCode: string;
  companyDomainCode: string;
  loginUser: string;
  UserLogOnId: string;
  Password: string;
  IsFirstTimeLogOn: string;
  UserLanguage: string;
  UserTimeZone: string;
  LogOnId: string;
  UserName: string;
  ClientBasePath: string;
  ChatAppId: string;
  GatewayCustomerCode: string;
  Uid: string;
  LogOnType: string;
  IsAuthenticate: string;
  Message: string;
  DomainCode: string;
  CompanyDomainCode: string;
  iss: string;
  aud: string;
  exp: string;
  nbf: string;
}

export interface IdentifiersModel {
  organizationKeyOne: number;
  organizationKeyTwo: number;
}

export interface EmployeeModel {
  employeeId: number;
  employeeCode: string;
  salutationName: string;
  employeePhoto: string;
  employeeName: string;
  businessUnit: string;
  department: string;
  subDepartment: string;
  grade: string;
  designation: string;
  branch: string;
  subBranch: string;
  level: string;
  company: string;
  imageVirtualPath: string;
  firstName: string;
  middleName: string;
  lastName: string;
  personalEmail: string;
  officialEmail: string;
  employeeStatus: string;
  employeeType: string;
  thumbnailFileName: string;
  uploadedFileName: string;
}


export const monthNames = {
  short: {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
  }
};


export const TaskStatus = {
  PENDING: 'PENDING',
  EXTENDED: 'EXTENDED',
  CONFIRMED: 'CONFIRMED',
  COMPLETED: 'COMPLETED',
  TERMINATED: 'TERMINATED',
  REJECTED: 'REJECTED',
};

export const monthDaysTill31 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
  18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];


export interface RecentImport {
  clientQueueId: string,
  importName: string,
  importType: string,
  domainCode: string,
  importOutputFile: string,
  importStatus: number,
  createTime: string,
  startTime: string,
  endTime: string,
  totalRecords: number,
  successCount: number,
  errorCount: number,
  runByAzureFunction: boolean,
  validatedFilePath: string,
  processedRecordCount: number,
  statusMessage: string
}

export type TLoginTokenResponse = {
  access_token: string,
  token_type: string,
  expires_in: number,
  refresh_token: string,
  userName: string,
  client_id: string,
  ".issued": string | Date,
  ".expires": string | Date,
  disableRememberMe: boolean,
  isMfaActive: string,
  mfa_auth_way: any[],
  redirectUri: string,
  rolloutVersion: string
}

export enum EMessageStatus {
  SUCCESS = "0",
  FAILED = "3",
}

export type TMessageResponse = {
  message: string,
  validationType: EMessageStatus,
  messageCode: string
}


export type HronePrimeNgFileUploadEvent<T = any> = {
  originalEvent: HttpEvent<T>
  files: File[]
}
export type HronePrimeNgFileRemoveEvent<T = any> = {
  originalEvent: HttpEvent<T>
  file: File
}


export type TKeyValue<K = number, V = string> = { key: K, value: V; };
export type TIdText<K = number, V = string> = { id: K, text: V };
export type HroneModelToTypeFormGroupItems<K> = { [id in keyof K]?: FormControl<K[id]> };
export type TypeToRequiredFormGroup<K> = { [id in keyof K]: FormControl<K[id]> };


export type TFileDownloadVirtualUrl = {
  folderName: string;
  fileDbName: string;
  fileVirtualPath: string;
  domainCode: string;
  fileName: string;
  requestSource: string;
}

export type TRights = {
  view: boolean;
  add: boolean;
  update: boolean;
  delete: boolean;
  import?: boolean;
}

export const expenseMonths = [
  {
    "monthId": "1,1,31",
    "monthName": "1 Jan - 31 Jan"
  },
  {
    "monthId": "2,1,28",
    "monthName": "1 Feb - 28 Feb"
  },
  {
    "monthId": "3,1,31",
    "monthName": "1 Mar - 31 Mar"
  },
  {
    "monthId": "4,1,30",
    "monthName": "1 Apr - 30 Apr"
  },
  {
    "monthId": "5,1,31",
    "monthName": "1 May - 31 May"
  },
  {
    "monthId": "6,1,30",
    "monthName": "1 Jun - 30 Jun"
  },
  {
    "monthId": "7,1,31",
    "monthName": "1 Jul - 31 Jul"
  },
  {
    "monthId": "8,1,31",
    "monthName": "1 Aug - 31 Aug"
  },
  {
    "monthId": "9,1,30",
    "monthName": "1 Sep - 30 Sep"
  },
  {
    "monthId": "10,1,31",
    "monthName": "1 Oct - 31 Oct"
  },
  {
    "monthId": "11,1,30",
    "monthName": "1 Nov - 30 Nov"
  },
  {
    "monthId": "12,1,31",
    "monthName": "1 Dec - 31 Dec"
  }
]

export const PROCESS_FOLDER_IDS = {
  announcement: {
    imageFolderId: 105,
    fileFolderId: 107,
    takeFileDBName: false
  },
  handbook: {
    imageFolderId: 108,
    fileFolderId: 108,
    takeFileDBName: true
  },
  candidateEngagement: {
    imageFolderId: 105,
    fileFolderId: 107,
    takeFileDBName: false
  },
  designation: {
    imageFolderId: 105,
    fileFolderId: 107,
    takeFileDBName: false
  },
  events: {
    imageFolderId: 105,
    fileFolderId: 107,
    takeFileDBName: false
  },
  alertDetail: {
    imageFolderId: 115,
    fileFolderId: 114,
    takeFileDBName: false
  },
  bookTravel: {
    imageFolderId: 115,
    fileFolderId: 114,
    takeFileDBName: false
  },
  upcomingEmployee: {
    imageFolderId: 115,
    fileFolderId: 114,
    takeFileDBName: false
  },
  emailTemplate: {
    imageFolderId: 115,
    fileFolderId: 114,
    takeFileDBName: false
  },
  positionPlanning: {
    imageFolderId: 115,
    fileFolderId: 114,
    takeFileDBName: false
  },
  jobOpening: {
    imageFolderId: 115,
    fileFolderId: 114,
    takeFileDBName: false
  },
};
export interface CommonListModel {
  id: number;
  text: string;
  isSelected?: boolean;
}

export interface ErrorMessageDetail {
  attendanceMonth: number;
  attendanceYear: number;
  messageCode: string;
  message: string;
}

export interface ValidationError {
  message: string;
  validationType: string;
  messageCode: string;
  errorMessageDetails: ErrorMessageDetail[];
}
export interface TaskViewDetailsModel {
  approvedBy: number;
  approvedDate: string; // ISO date string
  approverFirstName: string;
  approverLastName: string;
  approverMiddleName: string;
  assignDate: string; // ISO date string
  attachmentFileName: string;
  attachmentPath: string;
  checklistDueDay: number;
  checklistTaskId: number;
  currentUserLogOnType: string;
  department: string;
  domainCode: string;
  isTaskDepend: boolean;
  isVideoPathWebLink: boolean;
  logOnUserCode: string;
  logOnUserId: number;
  logOnUserName: string;
  mandatoryEmployeeCreation: boolean;
  remarks: string;
  taskId: number;
  taskName: string;
  taskStatus: boolean;
  totalTaskDepend: number;
  uploadedFileName: string;
  uploadedFilePath: string;
  uploadedVirtualPath: string;
  videoPath: string;
}

export interface PayrollGeneralSettingModel {
  logOnUserCode: string
  domainCode: string
  logOnUserId: number
  logOnUserName: string
  currentUserLogOnType: string
  leaveCashDays: number
  leaveExemption: number
  payArrearWithSalary: boolean
  overtimePartOfGross: boolean
  specialAllowanceRename: string
  settlementTriggerDays: number
  isGenerateLetterAfterSalaryRevision: boolean
  loanEdit: boolean
  loanInterestEdit: boolean
  bonusLimit: number
  specialAllowancePartOfProvidentFund: boolean
  implementationDate: string
  controlName: string
  schedulePayroll: number
  showDetailsOnEmployee: boolean
  houseRentExemptionUpToPaidRent: boolean
  calculateHouseAnnually: boolean
  houseAnnuallySettingSaved: boolean
  costToCompanyPassword: boolean
  slipPassword: boolean
  showTaxCalculatorOnInvestment: boolean
  mandatoryInvestmentProof: boolean
  investmentEditAllowed: boolean
  statutoryDetailsFromEmployee: boolean
  ensureMinimumWage: boolean
  ensureBasicWageLimitInCostToCompany: boolean
  verifyBankAccount: boolean
  fixedBonus: boolean
  allowPaymentAfterChallan: boolean
  isGenerateContractLetter: boolean
  isGenerateAppointmentLetter: boolean
  isCosttoCompanyNotApplicable: boolean
  overwritePFEmployeeLevel: boolean
  processEmployeeNPScheme: boolean
  historicalCostToCompany: boolean
  showProvidentFundReport: boolean
  hideViewDetails: boolean
  salaryProcessDays: number
  restrictedEndDay: number
  isFormSixteen: boolean
  goodsServicesTaxPercentage: number
  atalPensionScheme: boolean
  onlyOneReimbursementRequest: boolean
  restrictClaimMoreBill: boolean
  attachmentsInReimbursement: boolean
  numberOfComponentsAllow: number
  enableLoanGuarantor: boolean
  enableLoanGuarantorFeature: boolean
  guarantorRequiredCount: number
  guarantorCountLimit: number
  daysBeforeContractRenew: number
  ptExemptionEnable: boolean
  numberOfLanderAllow: number
  configureSalaryBank: boolean
  numberOfPayGroup: number
  houseRentAllowanceFormDeclaration: boolean
  enablePFProrateEmployee: boolean
  hideNewRegimeReimbursementBillRequest: boolean
  assignReimbursementTask: boolean
  excludedInvestmentEmployee: string
  excludedInvestmentEmployeeBy: number
  excludedInvestmentEmployeeOn: string
  assignInvestmentTask: boolean
  showAllComponentsInSalaryRegister: boolean
  bankBranch: boolean
  bankIndianFinancialSystemCode: boolean
  landlordPanMandatory: boolean
  showRemarkAttachmentCtc: boolean
  showForm12bb: number
  showBankIndianFinancialSystemCodeBranchHRDesk: boolean
  allowGroupInChallan: boolean
  dayCreateVariablePaymentPlanInboxRequest: number
  allowChangeTaxregime: boolean
  midmonthIncrement: number
  midmonthIncrementType: number
  isCosttoCompanyNotApplicableOnOffer: boolean
  hideChallanEditButton: boolean
  showPerqToEmployeeAndManager: boolean
  showVariableToEmployeeAndManager: boolean
  verifyEmployeesPanAadharLinkage?: boolean
  hideStatutoryDetailsFromEmployeeCTC: boolean
  npsApplicableOnArrear: boolean
  useAzureForPayslip: boolean
  autoPerquisite: boolean
  taxRegimePopupMandatory: boolean
  showPayByDefaultOnReimbursementReport: boolean
  useAzureForBackgroundProcess: boolean
  allowWagesNonCompliantSalaryStructure:boolean
  showWagesExclusionsToEmployee:boolean
  showSalaryInsightToEmployee:boolean
  attachmentMandatorySalaryStructure:boolean
  commentMandatorySalaryStructure:boolean
  enableIncrementCalculatorFeature: boolean
  showPayComponentOnZeroPaidAmount: boolean
  isCtcBalancerConfigured: boolean
  bankAccountValueRestriction: boolean
  bankAccountMinimumValue: number
  bankAccountMaximumValue: number
  bankAccountAllowedCharacters: string
  bankAccountOnlyNumericValue: boolean
  bankAccountOnlyAlphabeticalValue: boolean
  bankAccountOnlySpecialCharacters: boolean
  landlordPanVerification: boolean
  submitAndApproveSettlementImportRequest: boolean
  shareSettlementSlipsBySettlementImport: number
  enableLoanTenureExtensionByOneEmi: boolean
  useOldCalculatorConcept: boolean
  allowMinWagesSalaryStructure: boolean
  enableSectionAct2025: boolean
  wageComliantConfigured: boolean
}

export interface WorkforcePlanningSettingModel 
  {
    workforcePlanningId: number;
    isEmploymentType: boolean;
    isWorkforcePlanning: boolean;
    orgEnableType: number;
    isAllowViewHigher: boolean;
    isFloatingOnHire: boolean;
    isFloatingOnUpcomingJoin: boolean;
    isFloatingOnEmployee: boolean;
    isFloatingOnTransfer: boolean;
    isFloatingOnDoTransfer: boolean;
    isResignationUndoRestrict: boolean;
    isEditCTCOnJobRequisition: boolean;
    isEditExperienceOnJobRequisition: boolean;
    isEditJDOnJobRequisition: boolean;
    actionType: number;
    organization: WorkforceOrganization[];
  }

  export interface WorkforceOrganization {
    workforcePlanningId: number;
    organizationId: number;
  }



export interface KeyValueModel {
  key: number | string;
  value: string;
}